import script from "./currency_rate_table.vue?vue&type=script&setup=true&lang=js"
export * from "./currency_rate_table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__